import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '热播榜单', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: '专题合集', href: '#index' },
    { label: '移动观影', href: '#app' },
    { label: '联系我们', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-[60px] md:h-[68px]">
        <a
          href="#hero"
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-movie-2-fill text-background-50 text-lg"></i>
          </span>
          <span className="text-lg md:text-xl font-heading font-bold text-foreground-950">
            无极电影网
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 rounded-md hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm pointer-events-none"></i>
            <input
              type="text"
              placeholder="搜索电影、电视剧..."
              className="w-[180px] pl-9 pr-3 py-1.5 text-sm bg-background-100 border border-background-200/60 rounded-full text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors"
            />
          </div>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-foreground-950 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/60">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <div className="mt-2 px-3">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm pointer-events-none"></i>
                <input
                  type="text"
                  placeholder="搜索电影、电视剧..."
                  className="w-full pl-9 pr-3 py-2 text-sm bg-background-100 border border-background-200/60 rounded-full text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/50 transition-colors"
                />
              </div>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}